import { useMemo } from 'react'

import { useAvailablePaymentMethods } from '@/core/hooks/payment/usePaymentMethods'

/**
 * Hook to fetch and extract the card payment method ID
 *
 * @returns The card payment method ID or null
 */
export const useCardPaymentMethodId = () => {
	const { data } = useAvailablePaymentMethods()

	const cardPaymentMethodId = useMemo(() => {
		if (!data) return null

		const methods = data?.data || data || []
		const methodsArray = Array.isArray(methods) ? methods : []

		const cardMethod = methodsArray.find((method: any) => {
			const methodData = method?.data || method
			return methodData?.payment_type === 'CARD'
		})

		return cardMethod?.id || cardMethod?.paymentPlatformId || null
	}, [data])

	return cardPaymentMethodId
}
